export default "__VITE_ASSET__BBF13IQQ__";